interface Conf {
  httpTimeout?: number;
  generalMessageTimeout?: number;
}


export const AppConfig: Conf = {
  httpTimeout: 250000,
  generalMessageTimeout: 3000
};
